import { Category } from "../api/types";

export default function getCategoryLowercaseName(category: Category) {
    return Category[category].toLowerCase();
}